<h3 class="schema__advantage-item-title">{{ 'main.schemas.legalSupport' | translate }}</h3>

<div class="schema__card schema__paragraph-regular">
  {{ 'main.schemas.legalAssistance' | translate }}
</div>

<rp-home-coming-soon-label />
